/**
 * Canonical options for target schema column types in the Field Editor (PostgreSQL-oriented,
 * includes common SQL aliases). Values are lowercase for consistent JSON storage.
 * Unknown types from loaded schemas are still shown as extra menu items.
 */
export const SCHEMA_COLUMN_DATA_TYPES: readonly string[] = [
  'smallint',
  'integer',
  'int',
  'bigint',
  'serial',
  'bigserial',
  'real',
  'float',
  'double precision',
  'double',
  'numeric',
  'decimal',
  'money',
  'boolean',
  'char',
  'varchar',
  'text',
  'bytea',
  'date',
  'time',
  'timestamp',
  'timestamptz',
  'interval',
  'uuid',
  'json',
  'jsonb',
  'xml',
] as const;

/** Map legacy/uppercase known types to the lowercase canonical option for the select. */
export function canonicalizeKnownColumnType(raw: string | undefined): string {
  const t = (raw ?? 'varchar').trim() || 'varchar';
  const known = SCHEMA_COLUMN_DATA_TYPES as readonly string[];
  if (known.includes(t)) return t;
  const lower = t.toLowerCase();
  if (known.includes(lower)) return lower;
  return t;
}

export function columnTypeSelectOptions(current: string): string[] {
  const display = canonicalizeKnownColumnType(current);
  const base = [...SCHEMA_COLUMN_DATA_TYPES];
  if (base.includes(display)) {
    return base;
  }
  return [display, ...base];
}
